/**
 * Модальне вікно підтвердження невідповідності типу push-сповіщення.
 * Відображається коли обраний тип (text/html) не відповідає вмісту тіла.
 * Використовується у формах одиничних і масових сповіщень.
 *
 * Пропси:
 *   visible      {boolean}  — показати/сховати модалку
 *   selectedType {string}   — обраний тип ('text' | 'html')
 *   detectedType {string}   — виявлений тип ('text' | 'html')
 *   onConfirm    {function} — надіслати попри невідповідність
 *   onCancel     {function} — скасувати (також спрацьовує при кліку поза модалкою)
 */

import React from 'react';
import {
	CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CButton,
} from '@coreui/react';

const MESSAGES = {
	text_has_tags: {
		title: 'Невідповідність типу повідомлення',
		body: 'Ви зазначили тип «Текст», але повідомлення містить HTML-теги. Одержувач може побачити теги як звичайний текст замість відформатованого вмісту. Надіслати?',
	},
	html_no_tags: {
		title: 'Невідповідність типу повідомлення',
		body: 'Ви зазначили тип «HTML», але повідомлення не містить HTML-тегів. Можливо, ви мали на увазі тип «Текст». Надіслати?',
	},
};

const NotificationTypeMismatchModal = ({ visible, selectedType, detectedType, onConfirm, onCancel }) => {
	const key = selectedType === 'text' && detectedType === 'html'
		? 'text_has_tags'
		: 'html_no_tags';

	const { title, body } = MESSAGES[key];

	return (
		<CModal visible={visible} onClose={onCancel} alignment="center">
			<CModalHeader>
				<CModalTitle>{title}</CModalTitle>
			</CModalHeader>
			<CModalBody>{body}</CModalBody>
			<CModalFooter>
				<CButton color="secondary" variant="outline" onClick={onCancel}>
					Скасувати
				</CButton>
				<CButton color="success" onClick={onConfirm}>
					Надіслати
				</CButton>
			</CModalFooter>
		</CModal>
	);
};

export default NotificationTypeMismatchModal;
